import { render, staticRenderFns } from "./WfConsumerUserList.vue?vue&type=template&id=2497aefc&scoped=true&"
import script from "./WfConsumerUserList.vue?vue&type=script&lang=js&"
export * from "./WfConsumerUserList.vue?vue&type=script&lang=js&"
import style0 from "./WfConsumerUserList.vue?vue&type=style&index=0&id=2497aefc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2497aefc",
  null
  
)

export default component.exports